var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"dashboard",staticStyle:{"background-color":"#F0F0F0"},attrs:{"title":"Klienter"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"tool-text",attrs:{"slot":"tools","placeholder":"Søg","type":"text"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing)return;_vm.search=$event.target.value}},slot:"tools"}),_c('button-view',{staticStyle:{"float":"left"},attrs:{"slot":"tools"},on:{"click":_vm.createClient},slot:"tools"},[_vm._v("+ Klient")]),_c('new-table-view',{staticClass:"list",attrs:{"columns":[
			{
				label: 'ID',
				name: 'id'
			},
			{
				label: 'Sidste pakke',
				name: 'last_message',
				filter: 'timestamp'
			},
			{
				label: 'Version',
				name: 'current_version'
			},
			{
				label: 'Opdater til',
				name: 'update_version'
			},
			{
				label: 'Note',
				name: 'note'
			},
			{
				label: 'E-mail',
				name: 'email'
			},
			{
				label: '',
				name: 'context',
				align: 'right',
				template: {
					name: 'button',
					label: 'Publiser'
				},
				weight: '130px'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				},
				weight: '100px'
			}
		],"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext,"delete":_vm.itemDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }